import {
  SENSITIVE_DATA_BANK_ENTRY_MODE,
  SENSITIVE_DATA_BANK_ENTRY_MODE_KEY,
  SENSITIVE_DATA_MANUAL_BANK_KEY,
} from "constants/sensitiveData";
import { ManualBankAccountValues } from "types/Models/manualBankAccount";
import { SensitiveDataFormField } from "types/Models/sensitiveData";
import { SensitiveDataFormValues } from "util/buildSensitiveDataPayload";
import { useSaveManualBankAccount } from "hooks/useSaveManualBankAccount";

export const useWithManualBankAccount = ({
  fields,
  entityId,
  groupId,
}: {
  fields: SensitiveDataFormField[];
  entityId: string;
  groupId: string;
}): {
  withManualBankAccount: (
    values: SensitiveDataFormValues
  ) => Promise<SensitiveDataFormValues>;
  isSavingBankAccount: boolean;
} => {
  const { saveManualBankAccount, isSavingBankAccount } =
    useSaveManualBankAccount({ entityId, groupId });

  const bankField = fields.find(
    ({ data_type }) => data_type === "BANK_ACCOUNT"
  );

  const withManualBankAccount = async (values: SensitiveDataFormValues) => {
    if (!bankField) return values;

    const isManual =
      values[SENSITIVE_DATA_BANK_ENTRY_MODE_KEY] ===
      SENSITIVE_DATA_BANK_ENTRY_MODE.MANUAL;

    if (!isManual) return values;

    const manualBank = values[
      SENSITIVE_DATA_MANUAL_BANK_KEY
    ] as ManualBankAccountValues;

    const linkedBankId = values[bankField.field_key];
    const existingBankId =
      typeof linkedBankId === "string" && linkedBankId
        ? linkedBankId
        : undefined;

    const savedBank = await saveManualBankAccount(manualBank, existingBankId);

    return { ...values, [bankField.field_key]: savedBank.uuid };
  };

  return { withManualBankAccount, isSavingBankAccount };
};
